import { render, staticRenderFns } from "./outTab1.vue?vue&type=template&id=f4a4a87a&scoped=true&"
import script from "./outTab1.vue?vue&type=script&lang=js&"
export * from "./outTab1.vue?vue&type=script&lang=js&"
import style0 from "./outTab1.vue?vue&type=style&index=0&id=f4a4a87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4a87a",
  null
  
)

export default component.exports